import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@adv-mt/mt-modal-basic'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

const noop = () => {}

// eslint-disable-next-line react/prop-types
const ModalContent = () => {
  const {i18n} = useContext(Context)

  return (
    <div className="mt-ModalTransactionDiscover-claims">
      {i18n.t('VEHICLE_TRANSACTION.SAFE_SALE.CONFIRM_REJECT_REQUEST_SUBTITLE')}
    </div>
  )
}

const ModalRejectRequest = ({onModalClose = noop, onCtaClick = noop, onSecondaryCtaClick = noop, tradeId}) => {
  const {domain, i18n} = useContext(Context)
  const [isLoading, setIsLoading] = useState(false)

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')
  const imageUrl = `${urlStaticsImages}illustrations/site-come-back-soon.svg`

  const handleOnCtaClick = async () => {
    setIsLoading(true)

    const [error] = await domain.get('reject_trade_seller_transactions_use_case').execute({tradeId})
    setIsLoading(false)

    if (error) {
      return
    }

    onCtaClick()
  }

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={onModalClose}
      size="large"
    >
      <ModalBasicContent
        stepsContent={[
          {
            buttons: {
              cancelButton: {
                customCallBack: () => {
                  onSecondaryCtaClick()
                },
                text: i18n.t('COMMON.GO_BACK_1'),
                type: 'secondary'
              },
              confirmButton: {
                customCallBack: () => {
                  handleOnCtaClick()
                },
                isLoading,
                text: i18n.t('COMMON.REJECT_REQUEST_YES'),
                color: 'accent'
              }
            },
            children: <ModalContent />,
            headerImage: (
              <div className="mt-ModalTransactionDiscover-confirmRejectRequestContentHeaderImageWrapper">
                <AtomImage
                  alt={i18n.t('VEHICLE_TRANSACTION.SAFE_SALE.CONFIRM_REJECT_REQUEST')}
                  className="mt-ModalTransactionDiscover-confirmRejectRequestContentHeaderImage"
                  src={imageUrl}
                />
              </div>
            ),
            title: i18n.t('VEHICLE_TRANSACTION.SAFE_SALE.CONFIRM_REJECT_REQUEST')
          }
        ]}
      />
    </MoleculeModal>
  )
}

ModalRejectRequest.displayName = 'ModalRejectRequest'
ModalRejectRequest.propTypes = {
  onCtaClick: PropTypes.func,
  onModalClose: PropTypes.func,
  onSecondaryCtaClick: PropTypes.func,
  tradeId: PropTypes.string
}

export default ModalRejectRequest
